import { useState } from 'react'
import { FullScreenModal } from '../../utility/FullScreenModal'
import { SystemSS } from '../../components/SystemSS'

export const ButtleFlowStep1 = () => {
    const [showModal, setShowModal] = useState(false)
    const [modalContent, setModalContent] = useState({ contentType: '', category: '', index: 0 })
    const handleOpenModal = (contentType, category, index, maxIndex) => {
        setModalContent({ contentType, category, index, maxIndex })
        setShowModal(true)
    }
    const handleCloseModal = () => {
        setModalContent({ contentType: '', category: '', index: 0 })
        setShowModal(false)
    }
    return (
        <section>
            <div className='flex justify-center '>
                <img
                    className=''
                    alt='gameflow button'
                    src={`${process.env.PUBLIC_URL}/images/system/system-step1-fr.webp`}
                />
            </div>
            <div className='text-pbnavy font-kiwi font-bold text-sub md:text-base text-shadow-white w-full px-4 md:px-0 md:w-4/5 mx-auto mt-12'>
                <p className=' '>
                    Au début du combat, <span className='text-pborange'>Marona est l’unique unité alliée</span> présente
                    sur la carte. Avant de commencer, voici quelques éléments à prendre en compte.
                </p>
                <ol className='list-outside list-number ml-8 text-pborange mt-4'>
                    <li>1. « Quels types d’ennemis sont présents ? »</li> <li>2. « Quels objets sont présents ? »</li>{' '}
                    <li>3. « À quels objets puis-je combiner mes alliés ? »</li>
                </ol>
                <p className='mt-8'>
                    Il est également utile de vérifier les caractéristiques de la carte. Par exemple, le sol peut être
                    composé de glace glissante, etc.
                </p>{' '}
                {/* <SystemSS
                    mediaItems={[
                        {
                            modalId: 'flow-1',
                            index: 1,
                        },
                        {
                            modalId: 'flow-1',
                            index: 2,
                        },
                    ]}
                    handleOpenModal={handleOpenModal}
                    description='Take a look at the map in cursor mode. Be sure to carefully gather your intel!'
                /> */}
                <SystemSS
                    mediaItems={[
                        {
                            modalId: 'flow-1',
                            index: 1,
                        },
                    ]}
                    handleOpenModal={handleOpenModal}
                    description='Étudiez la carte en mode curseur. Assurez-vous de recueillir soigneusement tous les renseignements possibles !'
                />
                <p className=' '>
                    Lorsque vous étudiez la carte, vous pouvez aussi vérifier les <span className='text-pborange'>Protections</span>. Assurez-vous de les
                    utiliser à votre avantage au cours du combat. Les Protections sont représentées par une <span className='text-pborange'>ligne
                    lumineuse</span> reliant les personnages et les objets. Les personnages et les objets reliés par une ligne
                    lumineuse reçoivent le même <span className='text-pborange'>effet</span>. En vérifiant les points d’origine et d’arrivée des Protections,
                    vous pouvez en tirer un avantage stratégique !
                </p>{' '}
                <SystemSS
                    mediaItems={[
                        {
                            modalId: 'flow-1',
                            index: 2,
                        },
                    ]}
                    handleOpenModal={handleOpenModal}
                />
            </div>
            <FullScreenModal
                showModal={showModal}
                modalContent={modalContent}
                setModalImage
                handleCloseModal={handleCloseModal}
                setModalContent={setModalContent}
                maxIndex={2}
            />
        </section>
    )
}
